<template>
  <div>
    <v-alert type="info" text dense class="mb-4">
      {{ $t("finance_export_not_connected_notice") }}
    </v-alert>

    <v-card outlined class="pa-4 mb-4">
      <p class="text-overline grey--text text--darken-1 mb-2">{{ $t("finance_options_label") }}</p>
      <v-row dense>
        <v-col v-for="option in reportOptions" :key="option.key" cols="6" sm="4" md="3">
          <v-checkbox
            v-model="selectedOptions"
            :label="$t(option.labelKey)"
            :value="option.key"
            dense
            hide-details
            color="primary"
          />
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined class="pa-4 mb-4">
      <p class="text-overline grey--text text--darken-1 mb-2">{{ $t("finance_filter_label") }}</p>
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <date-picker v-model="dateRange" :label="$t('finance_period_label')" hide-details />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-radio-group v-model="format" :label="$t('finance_format_label')" hide-details row>
            <v-radio label="PDF" value="pdf" />
            <v-radio label="Excel" value="excel" />
            <v-radio label="CSV" value="csv" />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card>

    <div class="d-flex align-center flex-wrap" style="gap: 12px">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <primary-button disabled>
              <v-icon left>mdi-download</v-icon>
              {{ $t("finance_generate_report") }}
            </primary-button>
          </div>
        </template>
        <span>{{ $t("finance_export_not_connected_tooltip") }}</span>
      </v-tooltip>

      <span v-if="selectedOptions.length === 0" class="warn-copy">
        {{ $t("finance_select_at_least_one_option") }}
      </span>
      <span v-else class="hint-copy">
        {{ $t("finance_sections_selected", { count: selectedOptions.length, total: reportOptions.length }) }}
      </span>
    </div>
  </div>
</template>

<script>
const EXPORT_REPORT_OPTIONS = [
  { key: "turnover", labelKey: "finance_turnover" },
  { key: "payouts", labelKey: "finance_payouts_label" },
  { key: "invoices", labelKey: "finance_invoices_label" },
  { key: "commissions", labelKey: "finance_commissions_label" },
  { key: "refunds", labelKey: "finance_refunds_label" },
  { key: "promotions", labelKey: "finance_promotions_label" },
  { key: "transactions", labelKey: "finance_transactions_label" },
  { key: "balance-ledger", labelKey: "finance_balance_ledger_label" },
];

const toISODate = (date) => date.toISOString().slice(0, 10);

export default {
  name: "FinanceTabExport",

  data() {
    const reportOptions = EXPORT_REPORT_OPTIONS;
    return {
      reportOptions,
      selectedOptions: reportOptions.map((o) => o.key),
      dateRange: [
        toISODate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
        toISODate(new Date()),
      ],
      format: "pdf",
    };
  },
};
</script>

<style scoped>
.warn-copy {
  font-size: 0.85rem;
  color: #ef4444;
  font-weight: 600;
}

.hint-copy {
  font-size: 0.85rem;
  color: #9aa4b2;
}
</style>
